import { Clickable, Col, Spinner2 } from 'components';
import { theme } from 'lib';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const ImageBg = styled.img`
  object-fit: cover;
  width: 244px;
  height: 244px;
  position: absolute;
`;

const ImageMsg = ({ file, isSender, setImageVisible }) => {
  const [image, setImage] = useState(file);

  useEffect(() => {
    refetchImage();
  }, [file]);

  function refetchImage(err) {
    if (!isSender) return null;
    if (!err && file === image) return null;

    setImage('');

    setTimeout(() => {
      setImage(file);
    }, 500);
  }

  return (
    <React.Fragment>
      <Clickable onClick={() => setImageVisible(image)}>
        <Col ht="244px" wid="244px" marg="0 0 17px" overflow="hidden">
          <ImageBg
            onError={() => refetchImage(true)}
            src={image && typeof image === 'object' ? URL.createObjectURL(image) : image}
            style={!isSender ? { borderTopRightRadius: 22 } : { borderTopLeftRadius: 22 }}
          />

          {!image ||
            (typeof image !== 'string' && (
              <Col
                bg="rgba(0, 0, 0, 0.5)"
                ht="100%"
                centerAll
                wid="100%"
                ht="100%"
                zIndex="1"
                style={!isSender ? { borderTopRightRadius: 22 } : { borderTopLeftRadius: 22 }}
              >
                <Spinner2 col={theme.GREY_30} />
              </Col>
            ))}
        </Col>
      </Clickable>
    </React.Fragment>
  );
};

export default ImageMsg;
